import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.58 64 64 264.57 64 512s200.58 448 448 448 448-200.58 448-448S759.42 64 512 64z m77.25 606.31A32 32 0 1 1 544 715.57L363.43 535c-0.14-0.14-0.32-0.17-0.46-0.31a32.24 32.24 0 0 1 0-45.41c0.14-0.12 0.32-0.17 0.46-0.29L544 308.43a32 32 0 0 1 45.26 45.25L430.93 512z\" p-id=\"2018\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol